<script setup lang="ts">
import { useToast } from '../../composables/useToast'
import AppIcon from './AppIcon.vue'

const { toasts, dismiss } = useToast()

const icons: Record<string, string> = {
  success: 'check_circle',
  error: 'error',
  info: 'info',
  warning: 'warning',
}

const colors: Record<string, string> = {
  success: 'bg-success-50 border-success-500 text-success-700',
  error: 'bg-danger-50 border-error text-danger-700',
  info: 'bg-primary-50 border-primary text-primary-700',
  warning: 'bg-warning-50 border-tertiary text-warning-600',
}
</script>

<template>
  <div class="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-sm">
    <TransitionGroup
      enter-active-class="transition-all duration-300"
      leave-active-class="transition-all duration-200"
      enter-from-class="opacity-0 translate-x-4"
      leave-to-class="opacity-0 translate-x-4"
    >
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="['border-l-4 rounded p-3 shadow-[0_12px_24px_rgba(42,52,57,0.06)] flex items-start gap-2', colors[toast.type]]"
      >
        <AppIcon :name="icons[toast.type] ?? 'info'" size="sm" class="shrink-0 mt-0.5" />
        <span class="text-sm flex-1">{{ toast.message }}</span>
        <button @click="dismiss(toast.id)" class="text-current opacity-50 hover:opacity-100 cursor-pointer">
          <AppIcon name="close" size="sm" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
